import common from "@page/common/js/common";
import { fireRegisterEvent, fireRegisterGTMEventByLINE, fireRegisterGTMEventByFB } from "@global/gtm/login/register";

import { fireLoginEvent, fireLoginGTMEventByLINE, fireLoginGTMEventByFB } from "@global/gtm/login/login";

$(".btn-switch-block").click(function (e) {
	e.preventDefault();
	const target = $(this).data("block");
	const name = $(this).data("name");
	$(name).hide();
	$(target).fadeIn("slow");
});

$("#form-user-login").validate({
	errorClass: "error",
	errorElement: "div",
	rules: {
		account: "required",
		password: "required",
	},
	messages: {},
	errorPlacement: function (error, element) {
		element.parent().append(error);
	},
	submitHandler: function (form) {
		form.submit();
		fireLoginEvent();
	},
});

$("#form-user-forgot").validate({
	errorClass: "error",
	errorElement: "div",
	rules: {
		account: {
			required: true,
		},
	},
	messages: {},
	errorPlacement: function (error, element) {
		element.parent().append(error);
	},
	submitHandler: function (form) {
		const $btn = $(form).find("input[type='submit']");
		$btn.addClass("disabled");
		$.ajax({
			url: API_URL.FORGET_PS,
			type: "POST",
			dataType: "json",
			data: $(form).serialize(),
			success: function (res) {
				AlertDialog.alert(res.Message, function () {
					$btn.removeClass("disabled");
				});
			},
			error: function (xhr, textStatus, errorThrown) {
				console.log("error");
			},
		});
	},
});

$.validator.addMethod(
	"regx",
	function (value, element, regexpr) {
		return regexpr.test(value);
	},
	"invalid format."
);

$("#form-register").validate({
	errorClass: "error",
	errorElement: "div",
	rules: {
		account: {
			required: true,
			email: true,
		},
		password: {
			required: true,
			//change regexp to suit your needs
			regx: /^(?=.*\d)(?=.*[A-Za-z])[^\s]{6,15}$/,
		},
		checkpassword: {
			required: true,
			equalTo: "#password-signup",
		},
	},
	messages: {
		checkpassword: {
			equalTo: "The passwords entered are not the same.",
		},
	},
	errorPlacement: function (error, element) {
		element.parent().append(error);
	},
	submitHandler: function (form) {
		const $btn = $(form).find("input[type='submit']");
		$btn.addClass("disabled");
		$.ajax({
			url: API_URL.ACCOUNT_EXIST + "?Account=" + $(form).find('input[name="account"]').val(),
			type: "GET",
			dataType: "json",
			success: function (res) {
				if (res.Code == 200) {
					if (res.Response) {
						AlertDialog.alertBear(res.Message, function () {
							$btn.removeClass("disabled");
						});
					} else {
						form.submit();
						fireRegisterEvent();
					}
				} else {
					AlertDialog.alertBear("系統忙碌中，請稍後再試", function () {
						$btn.removeClass("disabled");
					});
				}
			},
			error: function (xhr, textStatus, errorThrown) {
				$btn.removeClass("disabled");
			},
		});

		return false;
	},
});

$(".btn-fb-login").on("click", function fbLogin() {
	if (this.parentElement.id === "form-user-login") {
		fireLoginGTMEventByFB();
	} else {
		fireRegisterGTMEventByFB();
	}
});

$(".btn-line-login").on("click", function lineLogin() {
	if (this.parentElement.id === "form-user-login") {
		fireLoginGTMEventByLINE();
	} else {
		fireRegisterGTMEventByLINE();
	}
});
